<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between upload-header">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto upload-title">
        Generar informe RX - {{ nombreServicio }} ({{ numeroOrden }})
      </h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Informes RX</span>
    </div>
  </div>
  <div class="d-flex my-xl-auto right-content mr-2 upload-actions d-none d-lg-flex">
    <div class="mb-3 mb-xl-0 upload-actions-group">
      <button type="button" class="btn btn-primary upload-btn-primary" (click)="guardarInforme()">
        <i class="icon ion-ios-filing"></i> GUARDAR INFORME
      </button>
      <button type="button" class="btn btn-light upload-btn-secondary" (click)="volverAtras()">VOLVER</button>
    </div>
  </div>
</div>

@if (spinnerBoolean) {
  <div class="text-center">
    <hr>
      <div class="spinner-grow" role="status"><span class="sr-only">Loading...</span></div>
      <p class="text-center">{{ cargando }}</p>
    </div>
  }

  @if (!spinnerBoolean) {
    <div class="row row-sm">
      <!-- DATOS DE LA ORDEN -->
      <div class="col-md-12">
        <div class="card order-summary-card">
          <h6 class="card-title text-uppercase p-2 text-white mb-1" style="background-color:#2E3D8C">
            Datos de la orden
          </h6>
          <div class="card-body order-summary-body">
            <div class="mb-2 summary-item">
              <b>PACIENTE</b>
              <p>{{ nombrePaciente }}</p>
            </div>
            <div class="mb-2 summary-item">
              <b>DOCTOR</b>
              <p>{{ nombreDoctor }}</p>
            </div>
            <div class="mb-2 summary-item">
              <b>SERVICIO</b>
              <p>{{ nombreServicio }} <span class="text-muted">({{ codigoServicio }})</span></p>
            </div>
          </div>
        </div>
      </div>
      <!-- IMÁGENES DEL SERVICIO -->
      @if (imagenesServicio.length > 0) {
        <div class="col-md-12">
          <div class="card detail-card">
            <h6 class="card-title text-uppercase p-2 text-white mb-1" style="background-color:#2E3D8C">
              Imágenes del servicio — {{ nombreServicio }}
            </h6>
            <div class="card-body">
              <hr>
                <div class="form-row">
                  @for (img of imagenesServicio; track img) {
                    <div class="col-md-6">
                      <img [src]="img" class="img-fluid" alt="imagen del servicio" />
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        <!-- ÁREA DEL INFORME -->
        <div class="col-md-12 d-none d-lg-block">
          <div class="card report-card desktop-report-card">
            <h6 class="card-title text-uppercase p-2 text-white mb-1" style="background-color:#2E3D8C">
              Redactar informe
            </h6>
            <div class="card-body report-card-body">
              <p class="report-helper-text d-lg-none">
                Redacta o dicta el informe y guárdalo cuando termines.
              </p>
              <textarea
                [(ngModel)]="informeHtml"
                class="col-md-12 form-control report-textarea"
                placeholder="Escriba el informe del estudio..."
                rows="12"
              ></textarea>
              @if (dictando && textoTemporal) {
                <div class="mt-2 p-2 border rounded text-muted">
                  <small>Dictando...</small><br />{{ textoTemporal }}
                </div>
              }
              <div class="report-actions mt-3">
                <button class="btn btn-warning report-action-btn me-2"
                  (click)="startDictation()" [disabled]="dictando">
                  🎤 Dictar
                </button>
                <button class="btn btn-danger report-action-btn me-2"
                  (click)="stopDictation()" [disabled]="!dictando">
                  ⛔ Detener dictado
                </button>
              </div>
              @if (safeAudioUrl) {
                <div class="mt-3">
                  <p class="mb-1"><b>Audio grabado:</b></p>
                  <audio [src]="safeAudioUrl" controls style="width:100%;"></audio>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-12 d-lg-none">
          <div class="card report-card mobile-report-card">
            <h6 class="card-title text-uppercase p-2 text-white mb-1" style="background-color:#2E3D8C">
              Informe general.
            </h6>
            <div class="card-body report-card-body">
              <p class="report-helper-text">
                Redacta o dicta el informe desde tu teléfono y guárdalo cuando termines.
              </p>
              <textarea
                [(ngModel)]="informeHtml"
                class="col-md-12 form-control report-textarea mobile-report-textarea"
                placeholder="Escriba el análisis..."
              ></textarea>
              @if (dictando && textoTemporal) {
                <div class="mt-2 p-2 border rounded text-muted">
                  <small>Dictando...</small><br />{{ textoTemporal }}
                </div>
              }
              <div class="report-actions-mobile">
                <button class="btn btn-info report-action-btn" (click)="startDictation()" [disabled]="dictando">
                  🎤 Dictar
                </button>
                <button class="btn btn-danger report-action-btn" (click)="stopDictation()" [disabled]="!dictando">
                  ⛔ Detener
                </button>
              </div>
              @if (safeAudioUrl) {
                <div class="mt-3">
                  <p class="mb-1"><b>Audio grabado:</b></p>
                  <audio [src]="safeAudioUrl" controls style="width:100%;"></audio>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <!-- BARRA INFERIOR MOBILE -->
    <div class="mobile-bottom-bar d-lg-none">
      <button type="button" class="btn btn-light mobile-bottom-bar__secondary" (click)="volverAtras()">
        Volver
      </button>
      <button type="button" class="btn btn-primary mobile-bottom-bar__primary" (click)="guardarInforme()">
        Guardar informe
      </button>
    </div>
